export default "__VITE_ASSET__8214c1bd__"